import { Button } from "../../../components/Button";
import Modal from "../../../components/Modal";

export function DeleteFileConfirmModal({
    isOpen,
    onClose,
    onConfirm,
    loading,
    file,
}: {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
    loading: boolean;
    file: any;
}) {
    return (

        <Modal title="Delete Document?" contentClassName="!w-[400px] [&_.title]:!text-[#B91C1C] [&>.title-container]:!px-0" isOpen={isOpen} handleModal={onClose}>
            <div className="flex flex-col mt-2 gap-4">
                <p className="text-[13px] text-gray-701 max-w-[300px]">This will permanently remove <span className="font-medium">{file?.file_name}</span> from Practice Materials. Sales reps will no longer be able to access it.</p>
                <div className="flex justify-end gap-2">
                    <Button variant="primary" onClick={onClose} disabled={loading} className="!bg-background3 !text-black px-5 h-[35px] !rounded-full !border-0">Cancel</Button>
                    <Button variant="primary" loading={loading} disabled={loading} onClick={onConfirm} className="px-5 py-0 !h-[35px] !rounded-full">Delete</Button>
                </div>
            </div>
        </Modal>
    )
}